import { useQuery } from '@tanstack/react-query';
import { getOrganizationClient } from '../lib/api-clients';
import { queryKeys } from '../lib/query-keys';

/**
 * Hook to fetch the current organization.
 * Uses TanStack Query for caching and state management.
 */
export function useCurrentOrganization() {
  return useQuery({
    queryKey: queryKeys.organizations.current(),
    queryFn: () => getOrganizationClient().getCurrent(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false,
  });
}

/**
 * Hook to fetch scheduling context (practice timezone, today's date,
 * whether locations are still open, earliest schedulable date).
 */
export function useSchedulingContext() {
  return useQuery({
    queryKey: ['schedulingContext'],
    queryFn: () => getOrganizationClient().getSchedulingContext(),
    staleTime: 60 * 1000, // 1 minute — time-sensitive
  });
}
